<template>
  <div>
    <div style="margin-top: 10px">
      <van-field v-model="positionFrom.Name" label="企业名称" required placeholder="请输入企业名称" />
      <van-field
        v-model="positionFrom.OrgName"
        label="社区"
        required
        placeholder="请选择社区（村）"
        @click="OrgCodeShow = true"
        readonly="readonly"
      />
      <van-popup v-model="OrgCodeShow" position="bottom" get-container="body">
        <van-cascader
          title="请选择社区（村）"
          :options="orgList"
          @close="OrgCodeShow = false"
          :field-names="{ text: 'OrganName', value: 'OrganCode', children: 'Children' }"
          @finish="onOrgCode"
        />
      </van-popup>
      <van-field
        v-model="positionFrom.GName"
        label="网格"
        required
        placeholder="请选择网格"
        @click="idListGId = true"
        readonly="readonly"
      />
      <van-popup v-model="idListGId" position="bottom" get-container="body">
        <van-picker
          show-toolbar
          :columns="gidlist"
          value-key="Title"
          @cancel="idListGId = false"
          @confirm="onidListGId"
        >
        </van-picker>
      </van-popup>
      <van-field v-model="positionFrom.ShortName" label="企业简称" placeholder="请输入企业简称" />
      <van-field
        v-model="positionFrom.ETypeName"
        label="企业类型"
        placeholder="请选择企业类型"
        @click="EType = true"
        readonly="readonly"
        required
      />
      <van-popup v-model="EType" position="bottom" get-container="body" @open="eTypeOpen">
        <div style="margin: 2%;">
          <van-checkbox-group v-model="positionFrom.EType" direction="horizontal" @change="eTypeClose">
            <van-checkbox
              v-for="item in leixing"
              :key="item.dictValue + 'aa'"
              :name="item.dictValue"
              style="margin: 2%;"
              >{{ item.dictLabel }}</van-checkbox
            >
          </van-checkbox-group>
        </div>
        <!-- <van-button block round type="info" @click="eTypeConfirm">确定</van-button> -->
        <!-- <van-picker show-toolbar :columns="leixing" value-key="dictLabel" @cancel="EType = false" @confirm="onEType">
        </van-picker> -->
      </van-popup>
      <!-- <van-field
        v-model="positionFrom.IndName"
        label="所属行业"
        required
        placeholder="请选择所属行业"
        @click="AbilityCode = true"
        readonly="readonly"
      />
      <van-popup v-model="AbilityCode" position="bottom" get-container="body">
        <van-cascader
          title="请选择所属行业"
          :options="hangye"
          @close="AbilityCode = false"
          :field-names="{ text: 'Name', value: 'Coding', children: 'Children' }"
          @finish="onAbilityCode"
        />
      </van-popup> -->
      <van-field v-model="positionFrom.LicCode" label="营业执照" required placeholder="请输入营业执照" />
      <van-field v-model="positionFrom.CoScale" label="企业规模" placeholder="请输入企业人数" />
      <van-field v-model="positionFrom.Charger" label="负责人" required placeholder="请输入负责人" />
      <van-field v-model="positionFrom.TouchTel" label="负责人电话" required placeholder="请输入负责人电话" />
      <van-field
        v-model="positionFrom.FoundDate"
        label="成立日期"
        @click="FoundDate = true"
        readonly="readonly"
        placeholder="请输入成立日期"
      />
      <van-popup v-model="FoundDate" position="bottom" get-container="body">
        <van-datetime-picker
          show-toolbar
          type="date"
          title="选择成立日期"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="FoundDate = false"
          @confirm="onFoundDate"
        >
        </van-datetime-picker>
      </van-popup>
      <van-field v-model="positionFrom.RegCapital" label="注册资本" placeholder="请输入注册资本" />
      <van-field v-model="positionFrom.CoTel" label="固定电话" placeholder="请输入固定电话" />
      <van-field v-model="positionFrom.CoEMail" label="企业邮箱" placeholder="请输入企业邮箱" />
      <van-field v-model="positionFrom.Homepage" label="企业主页" placeholder="请输入企业主页" />
      <van-field v-model="positionFrom.MicroBlog" label="企业微博" placeholder="请输入企业微博" />
      <van-field v-model="positionFrom.WeChat" label="企业公众号" placeholder="请输入企业公众号" />
      <van-field v-model="positionFrom.Address" label="地址" required placeholder="请输入地址" />
      <van-field
        v-model="positionFrom.BusinessScope"
        label="经营范围"
        rows="3"
        autosize
        type="textarea"
        placeholder="请输入经营范围"
      />
      <!-- <van-field
        v-model="positionFrom.Summary"
        label="简介"
        rows="3"
        autosize
        type="textarea"
        placeholder="请输入简介"
      /> -->
      <div class="submit" style="padding: 10px 7px">
        <span style="color: red; font-size: 14px; letter-spacing: 8px"></span>
        <span style="color: #646566; font-size: 14px">简介</span>
      </div>
      <div style="width:90%;margin:auto;">
        <Editor :value.sync="positionFrom.Summary" />
      </div>
      <div class="submit" style="padding: 10px 7px">
        <span style="color: red; font-size: 14px; letter-spacing: 8px"></span>
        <span style="color: #646566; font-size: 14px">成功案例</span>
      </div>
      <div style="width:90%;margin:auto;">
        <Editor :value.sync="positionFrom.SucCase" />
      </div>
      <div class="submit" style="padding: 10px 7px">
        <span style="color: red; font-size: 14px; letter-spacing: 8px"></span>
        <span style="color: #646566; font-size: 14px">营业执照</span>
      </div>
      <van-uploader
        v-model="jkImageList"
        multiple
        capture="camera"
        class="imgs"
        :max-count="1"
        :after-read="afterRead"
        :before-delete="jkDelete"
        :deletable="true"
      />

      <div class="submit" style="padding: 10px 7px">
        <span style="color: red; font-size: 14px; letter-spacing: 8px"></span>
        <span style="color: #646566; font-size: 14px">企业图片</span>
      </div>
      <van-uploader
        v-model="ShopImgList"
        multiple
        capture="camera"
        class="imgs"
        :max-count="9"
        :after-read="ShopImgRead"
        :before-delete="xcDelete"
        :deletable="true"
      />
      <van-field
        v-model="positionFrom.Remark"
        label="备注"
        rows="2"
        autosize
        type="textarea"
        placeholder="请输入备注"
      />
      <!-- <van-field
            v-model="positionFrom.WorkAddrName"
            label="工作地点"
            placeholder="请选择工作地点"
            @click="WorkAddrCode = true"
            readonly="readonly"
          />
          <van-popup
            v-model="WorkAddrCode"
            position="bottom"
            get-container="body"
          >
            <van-cascader
              title="请选择工作地点"
              :options="NativeCantonCodedata"
              @close="WorkAddrCode = false"
              :field-names="{
                text: 'text',
                value: 'value',
                children: 'children',
              }"
              @finish="onWorkAddrCode"
            />
          </van-popup> -->
      <div class="fromButton">
        <van-button @click="SaveJob" round type="info">提 交</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Dialog } from 'vant'
import { Toast } from 'vant'
Vue.use(Toast)
Vue.use(Dialog)
import { RE_SaveJob, GetAbilityList, RE_SaveEnterprise, RE_GetMyEnterprise } from '@/api/REplat'
import { GetCodeEntrysList } from '@/api/ResumeJS'
import { getaccToken, setaccToken } from '@/utils/auth'
import { WeGetGridList, GetOrgansNullToken } from '@/api/yeguang'
import config from '@/config'
import Compressor from 'compressorjs'
import axios from 'axios'
import Editor from '../shop/Editor/index' // 富文本编辑器
export default {
  components: {
    Editor,
  },
  data() {
    return {
      // 营业执照
      jkImageList: [],
      ShopImgList: [],
      ShopImgLists: [],
      positionFrom: {
        //保存
        EId: 0, //企业Id、
        Name: '', //名称、
        OrgCode: '',
        OrgName: '',
        GName: '',
        LicCode: '',
        ShortName: '', //简称、
        EType: '', //类型（类别：254）、
        RegCapital: '', //注册资本、
        IndCode: '', //行业编码、
        Charger: '', //负责人、
        TouchTel: '', //负责人联系方式、
        Address: '', //地址、
        Coordinate: '', //坐标、
        CoScale: '', //企业规模、
        CoTel: '', //电话、
        CoEMail: '', //邮箱、
        Homepage: '', //主页、
        MicroBlog: '', //微博、
        WeChat: '', //微信公众号、
        FoundDate: '', //成立日期、
        Summary: '', //简介、
        License: '', //营业执照、
        LicCode: '', //营业执照编号、
        BusinessScope: '', //经营范围、
        Remark: '', //备注
        accToken: getaccToken(),
      },
      // 选择器
      zhiye: [],
      xveli: [],
      hangye: [],
      NativeCantonCodedata: [],
      jinji: [
        { id: 1, text: '一般' },
        { id: 2, text: '紧急' },
        { id: 3, text: '非常紧急' },
      ],
      zhuangtai: [
        { id: 1, text: '招聘中' },
        { id: 1, text: '暂缓招聘' },
        { id: 1, text: '招聘结束' },
      ],
      minDate: new Date(1970, 0),
      maxDate: new Date(),
      //选择器显示与隐藏
      Education: false,
      Status: false,
      EType: false,
      Urgency: false,
      AbilityCode: false,
      WorkAddrCode: false,
      FoundDate: false,
      OrgCodeShow: false,
      leixing: [],
      orgList: [],
      gidlist: [],
      idListGId: false,
    }
  },
  created() {
    this.GetMyEnterprise()
    this.zidianlist()
    this.getOrgCodeList()
    this.getGidList()
  },
  methods: {
    // 获取社区村
    getOrgCodeList() {
      GetOrgansNullToken().then((res) => {
        console.log(res)
        this.orgList = res.data.data
      })
    },
    // 打开企业类型弹窗
    eTypeOpen() {
      console.log(this.positionFrom.EType)
      if (this.positionFrom.EType != null && this.positionFrom.EType != '') {
        this.positionFrom.EType = this.positionFrom.EType.split(',')
      }
    },
    // 选中企业类型
    eTypeClose(e) {
      var ETypeName = []
      e.forEach((a) => {
        this.leixing.forEach((b) => {
          if (b.dictValue == a) {
            ETypeName.push(b.dictLabel)
          }
        })
      })
      this.positionFrom.ETypeName = ETypeName.join(',')
    },
    // 保存
    SaveJob: function() {
      console.log(this.positionFrom)
      if (this.positionFrom.Name == '') {
        Toast.fail('企业名称不能为空!')
        return false
      }
      if (this.positionFrom.OrgName == null || this.positionFrom.OrgName == '') {
        Toast.fail('社区不能为空!')
        return false
      }
      if (this.positionFrom.GName == null || this.positionFrom.GName == '') {
        Toast.fail('网格不能为空!')
        return false
      }
      // if (this.positionFrom.LicCode == '') {
      //   Toast.fail('社会信用编码不能为空!')
      //   return false
      // }

      if (this.positionFrom.EType == null || this.positionFrom.EType.length == 0) {
        Toast.fail('请选择企业类型')
        return false
      }
      if (this.positionFrom.Charger == '') {
        Toast.fail('负责人不能为空!')
        return false
      }
      if (this.positionFrom.TouchTel == '') {
        Toast.fail('负责人联系电话不能为空!')
        return false
      }
      if (this.positionFrom.Address == '') {
        Toast.fail('地址不能为空!')
        return false
      }
      if (this.positionFrom.LicCode == '') {
        Toast.fail('营业执照编号不能为空!')
        return false
      }
      if (this.positionFrom.FoundDate == '') {
        Toast.fail('成立时间不能为空!')
        return false
      }
      if (Array.isArray(this.positionFrom.EType)) {
        this.positionFrom.EType = this.positionFrom.EType + []
      }
      if (this.ShopImgLists.length > 0) {
        this.positionFrom.Imgs = this.ShopImgLists + ''
      } else {
        this.positionFrom.Imgs = ''
      }
      //保存职位
      // this.positionFrom.EId = getaccToken()
      RE_SaveEnterprise(this.positionFrom).then((res) => {
        if (res.data.code == 0) {
          Dialog.alert({
            title: '提示',
            message: '提交成功!',
          }).then(() => {
            this.$router.go(-1)
            // this.$router.push({ path: '/list/company' })
          })
        } else {
          Dialog.alert({
            title: '提示',
            message: '提交失败!' + res.data.msg,
          }).then(() => {
            // on close
          })
        }
      })
    },
    // 获取企业详情
    GetMyEnterprise: function() {
      console.log(getaccToken())
      RE_GetMyEnterprise(getaccToken()).then((res) => {
        console.log(res)
        this.positionFrom = res.data.data
        if (res.data.data.License != null && res.data.data.License != '') {
          //营业执照
          this.jkImageLists = [res.data.data.License]
          var arrYe = []
          this.jkImageLists.forEach(function(imgUrl) {
            arrYe.push({ name: imgUrl, url: imgUrl })
          })
          this.jkImageList = arrYe
          this.positionFrom.License = res.data.data.License
        }
        //企业照片
        if (res.data.data.Imgs != null && res.data.data.Imgs != '') {
          this.ShopImgLists = [res.data.data.Imgs]
          var arr = []
          this.ShopImgLists.forEach(function(imgUrl) {
            arr.push({ url: imgUrl })
          })
          this.ShopImgList = arr
          this.positionFrom.Imgs = res.data.data.Imgs
        }
        if (res.data.data.OrgCode != null && res.data.data.OrgCode != '') {
          this.gidlist.forEach((a) => {
            if (res.data.data.GId == a.GId) {
              this.positionFrom.GName = a.Title
            }
          })
        }
        // this.positionFrom.ESort = 2
      })
    },
    // 字典
    zidianlist: function() {
      // 类型
      GetCodeEntrysList('item_256').then((res) => {
        this.leixing = res.data.data
      })
      // 类型
      GetAbilityList('item_202').then((res) => {
        this.hangye = res.data.data
      })
      GetAbilityList().then((res) => {
        this.zhiye = res.data.data
      })
      // 地区
      // GetCodeEntrysList({ kind: '2' }).then((res) => {
      //   var Citys = [],
      //     Citysx = [],
      //     Citysq = [],
      //     Citysqp = [],
      //     list = res.data.data
      //   for (var i = 0; i < list.length; i++) {
      //     if (list[i].Coding.length == '2') {
      //       Citys.push({
      //         value: list[i].Coding,
      //         children: [],
      //         text: list[i].Alias,
      //       })
      //     } else if (list[i].Coding.length == '4') {
      //       Citysx.push({
      //         value: list[i].Coding,
      //         children: [],
      //         text: list[i].Alias,
      //       })
      //     } else if (list[i].Coding.length == '6') {
      //       if (list[i].Coding == '410324') {
      //         Citysq.push({
      //           value: list[i].Coding,
      //           text: list[i].Alias,
      //           children: [],
      //         })
      //       } else {
      //         Citysq.push({ value: list[i].Coding, text: list[i].Alias })
      //       }
      //     } else if (list[i].Coding.length > '6') {
      //       if (list[i].Coding.substr(0, 6) == '410324') {
      //         Citysqp.push({ value: list[i].Coding, text: list[i].Alias })
      //       }
      //     }
      //   }
      //   for (var p = 0; p < Citysq.length; p++) {
      //     if (Citysq[p].value.substr(0, 6) == '410324') {
      //       Citysq[p].children = Citysqp
      //     }
      //   }
      //   for (var i = 0; i < Citysq.length; i++) {
      //     for (var j = 0; j < Citysx.length; j++) {
      //       if (Citysq[i].value.substr(0, 4) == Citysx[j].value) {
      //         Citysx[j].children.push(Citysq[i])
      //       }
      //     }
      //   }
      //   for (var z = 0; z < Citysx.length; z++) {
      //     for (var y = 0; y < Citys.length; y++) {
      //       if (Citysx[z].value.substr(0, 2) == Citys[y].value) {
      //         Citys[y].children.push(Citysx[z])
      //       }
      //     }
      //   }
      //   this.NativeCantonCodedata = Citys
      //   this.NativeCantonCodedataCs = Citys
      // })
    },
    onEType(val) {
      this.positionFrom.EType = val.dictValue
      this.positionFrom.ETypeName = val.dictLabel
      this.EType = false
    },
    onFoundDate(val) {
      //个人详情 出生日期
      this.positionFrom.FoundDate = this.dateformat(val)
      this.FoundDate = false
    },
    dateformat(val) {
      // 时间格式化事件 yy-mm-dd
      let year = val.getFullYear()
      let month = val.getMonth() + 1
      let day = val.getDate()
      if (month >= 1 && month <= 9) {
        month = `0${month}`
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`
      }
      return `${year}-${month}-${day}`
    },
    // 选择社区村
    onOrgCode({ selectedOptions }) {
      console.log(selectedOptions)

      this.positionFrom.OrgName = selectedOptions.map((option) => option.OrganName).join('/')
      this.positionFrom.OrgCode = selectedOptions[selectedOptions.length - 1].OrganCode
      this.OrgCodeShow = false
      this.gidlist = []
      this.positionFrom.GId = undefined
      this.positionFrom.GName = undefined
      this.getGidList()
    },
    // 获取网格
    getGidList() {
      WeGetGridList({ limit: 99, organCode: this.positionFrom.OrgCode }).then((res) => {
        // console.log(res.data)
        this.gidlist = res.data.data
      })
    },
    // 小区(组)选择器
    onidListGId(val) {
      this.positionFrom.GId = val.GId
      this.positionFrom.GName = val.Title
      this.idListGId = false
    },
    onAbilityCode({ selectedOptions }) {
      console.log(selectedOptions)
      //状态况选择器
      // this.positionFrom.IndCode = val.Coding
      // this.positionFrom.IndName = val.Name

      this.positionFrom.IndName = selectedOptions.map((option) => option.Name).join('/')
      this.positionFrom.IndCode = selectedOptions[selectedOptions.length - 1].Coding
      this.AbilityCode = false
    },
    onWorkAddrCode: function(value) {
      //工作地点
      var RegCity = this.addressfrom(value)
      this.positionFrom.WorkAddrCode = RegCity[0]
      this.positionFrom.WorkAddrName = RegCity[1]
      this.WorkAddrCode = false
    },
    addressfrom(value) {
      //地址
      var a, b, c
      a = value.selectedOptions[0]
      b = value.selectedOptions[1]
      c = value.selectedOptions[2]
      var addressCode = c.value
      var addressName = a.text + ',' + b.text + ',' + c.text
      var address = [addressCode, addressName]
      return address
    },

    //上传营业执照
    afterRead(file) {
      var that = this
      file.status = 'uploading'
      file.message = '上传中...'
      new Compressor(file.file, {
        quality: 0.5,
        success(result) {
          var formData = new FormData()
          let c = {
            headers: { 'Content-Type': 'multipart/form-data' },
          }
          //构造一个 FormData，把后台需要发送的参数添加
          formData.append('file', result, result.name)
          axios.post(config.apiUploadUrl, formData, c).then((res) => {
            if (res.data.code === 0) {
              console.log(res.data.msg)
              that.positionFrom.License = res.data.msg
              // that.datafrom.EvalImgs.push(res.data.data);
              file.status = ''
              file.message = ''
            } else {
              Toast.fail(res.data.msg)
            }
          })
        },
      })
    },
    //删除营业执照
    jkDelete(file) {
      this.jkImageList = []
      this.positionFrom.License = ''
    },

    //上传商铺图片
    ShopImgRead(file) {
      var that = this
      file.status = 'uploading'
      file.message = '上传中...'
      new Compressor(file.file, {
        quality: 0.5,
        success(result) {
          var formData = new FormData()
          let c = {
            headers: { 'Content-Type': 'multipart/form-data' },
          }
          //构造一个 FormData，把后台需要发送的参数添加
          formData.append('file', result, result.name)
          axios.post(config.apiUploadUrl, formData, c).then((res) => {
            if (res.data.code === 0) {
              // console.log(res.data.msg)
              // that.positionFrom.Imgs = res.data.msg
              // that.positionFrom.Imgs.push(res.data.msg)
              that.ShopImgLists.push(res.data.msg)
              file.status = ''
              file.message = ''
            } else {
              Toast.fail(res.data.msg)
            }
          })
        },
      })
    },
    //删除商铺图片
    xcDelete(file, fileList) {
      this.ShopImgLists.splice(fileList.index, 1)
      this.ShopImgList.splice(fileList.index, 1)
      // this.ShopImgList = []
      // this.ShopImgLists = ''
    },
  },
}
</script>
<style></style>
